module.exports = __webpack_public_path__ + "static/media/logo.44838a7a.svg";